import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { ArrowRight, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { Spinner } from "@/components/common";

const BrandPanel = () => (
  <div className="cc-grid-bg relative hidden flex-1 flex-col justify-between overflow-hidden border-r border-[#1e293b] p-14 lg:flex">
    <div className="pointer-events-none absolute -right-40 top-1/4 h-[520px] w-[520px] rounded-full border border-emerald-500/10" />
    <div className="pointer-events-none absolute -right-20 top-1/3 h-[320px] w-[320px] rounded-full border border-emerald-500/20" />
    <div className="cc-eyebrow text-emerald-400/80">Command Center · v0</div>
    <div className="am-rise">
      <h1 className="font-display text-6xl font-extrabold uppercase leading-[0.9] tracking-tight text-slate-50 xl:text-7xl">
        Ads<br /><span className="text-emerald-400">Monster</span>
      </h1>
      <p className="mt-6 max-w-md text-base leading-relaxed text-slate-400">
        Your AI Google Ads manager for The Rehab Lab. It studies your website, reads your live campaigns, and drafts the plan.
      </p>
    </div>
    <div className="grid max-w-md grid-cols-3 gap-6 font-mono text-[11px] uppercase tracking-wider text-slate-500">
      <div><div className="text-emerald-400">01</div>Connect</div>
      <div><div className="text-emerald-400">02</div>Audit</div>
      <div><div className="text-emerald-400">03</div>Plan</div>
    </div>
  </div>
);

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      navigate("/dashboard");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen bg-[#070a11]">
      <BrandPanel />
      <div className="flex flex-1 items-center justify-center p-6 lg:max-w-xl">
        <form onSubmit={submit} data-testid="login-form" className="am-rise w-full max-w-sm">
          <div className="mb-10 lg:hidden">
            <div className="font-display text-4xl font-extrabold uppercase text-slate-50">Ads<span className="text-emerald-400">Monster</span></div>
          </div>
          <div className="cc-eyebrow mb-3 flex items-center gap-2"><Lock className="h-3 w-3" /> Owner access</div>
          <h2 className="font-display text-3xl font-bold uppercase tracking-tight text-slate-100">Sign in</h2>
          <div className="mt-8 space-y-5">
            <label className="block">
              <span className="cc-eyebrow">Email</span>
              <input data-testid="login-email-input" type="email" required autoComplete="username" className="cc-input mt-2" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="owner@therehablabsg.com" />
            </label>
            <label className="block">
              <span className="cc-eyebrow">Password</span>
              <input data-testid="login-password-input" type="password" required autoComplete="current-password" className="cc-input mt-2" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••••••" />
            </label>
            {error && <div data-testid="login-error" className="rounded-md border border-red-500/30 bg-red-500/10 px-3 py-2 text-sm text-red-300">{error}</div>}
            <button data-testid="login-submit-button" type="submit" disabled={busy} className="cc-btn cc-btn-primary w-full py-2.5">
              {busy ? <Spinner className="h-4 w-4 text-[#03130c]" /> : <>Enter command center <ArrowRight className="h-4 w-4" /></>}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
